import { __name } from './chunk-7QVYU63E.js';

// ../base/config/index.ts
var ConfigBase = class {
  static {
    __name(this, "ConfigBase");
  }
  getConfig;
  config;
  constructor(getConfig) {
    this.getConfig = getConfig;
  }
  initialize(env) {
    this.config = this.getConfig(env);
  }
  /**
   * Get a copy of the config object
   */
  get() {
    if (typeof this.config === "undefined") {
      throw new Error("Companion config has not been initialized!");
    }
    return {
      ...this.config,
      ...JSON.parse(JSON.stringify(this.config))
    };
  }
  /**
   * Returns a function that always gets the latest state from the config based on the given selector.
   *
   * @example
   * ```ts
   * const getSomeConfValue = config.select((conf) => {
   *   return conf.someValue;
   * });
   *
   * getSomeConfValue(); // returns `conf.someValue`
   * ```
   */
  select(selector) {
    return () => selector(this.get());
  }
  /**
   * Update configuration object by mutation
   *
   * Pass a function that receives a copy of the current config.
   * Any mutations to this copy will be applied as the new config object.
   *
   * @example
   * ```ts
   * config.set((existingConfig) => {
   *   existingConfig.someProp = 1234;
   *   existingConfig.nested.prop = 'abcd';
   * })
   * ```
   */
  set(updateConfig) {
    const configCopy = this.get();
    updateConfig(configCopy);
    this.config = Object.assign(this.config ?? {}, configCopy);
  }
};

// src/config/index.ts
var config = new ConfigBase((env) => {
  const cookiePrefix = "jw_";
  const cookieSuffix = env === "prd" ? "" : `_${env}`;
  return {
    env,
    auth: {
      fromAdminQueryParam: "auth-from-admin",
      tokenTtl: {
        stale: 4 * 24 * 60 * 60 * 1e3,
        // 4 days to refresh a token
        expired: 4.9 * 24 * 60 * 60 * 1e3
        // 5 days: validity on server. We'll add a buffer for the frontend.
      },
      cookies: {
        token: `${cookiePrefix}auth_gateway${cookieSuffix}`,
        mfa: {
          identifier: `${cookiePrefix}auth_gateway_mfa${cookieSuffix}`,
          ttl: 60 * 60 * 24 * 14
          // 14 days
        },
        authFromAdmin: `${cookiePrefix}auth_gateway_from_admin${cookieSuffix}`,
        activeSiteId: `${cookiePrefix}active_site_id${cookieSuffix}`
      }
    },
    urls: {
      apiGateway: "",
      contentServer: ""
    },
    upload: {
      direct: {
        // 100 MB
        maxSize: 100 * 1e3 ** 2
      },
      multipart: {
        maxRetries: 3,
        timeBetweenRetries: 3e3,
        // 10 MB
        partSize: 10 * 1e3 ** 2,
        maxConcurrentParts: 3
      }
    }
  };
});

export { config };
//# sourceMappingURL=chunk-QOFPRZSL.js.map
//# sourceMappingURL=chunk-QOFPRZSL.js.map